import script from "./GradeManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeManagement.vue?vue&type=script&setup=true&lang=js"

import "./GradeManagement.vue?vue&type=style&index=0&id=778219c4&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-778219c4"]])

export default __exports__